module.exports = __webpack_public_path__ + "static/media/NG.60dac386.svg";